import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';

export const formatEnumValue = (enumValue: string | null | undefined): string => {
	if (!enumValue) {
		return LONG_DASH;
	}

	return enumValue
		.toLowerCase()
		.replace(/_/g, ' ')
		.replace(/\b\w/g, (char) => char.toUpperCase());
};
